import React from "react";
import T from "prop-types";
import { Field } from "redux-form";
import { Select } from "MODULES/shared/components/Forms";
import { QUALITY_CONTROL, ROLES } from "MODULES/users/constants";
import withCurrentUser, {
  WithCurrentUser
} from "MODULES/session/decorators/withCurrentUser";
import { disableIfHasAnyOfRoles } from "MODULES/users/helpers";
import { without } from "lodash";
import { SELL_AS_ALT_ID } from "MODULES/OutgoingQuotes/constants";

function SellAsAlt({
  alternates,
  cancelled,
  exchanged,
  currentUser,
  shipped,
  canEditPartDetails = true
}) {
  const options = alternates.map(a => ({
    value: a.id,
    text: a.name
  }));
  const disabled =
    (cancelled || exchanged || shipped || !canEditPartDetails) &&
    disableIfHasAnyOfRoles(currentUser, without(ROLES, QUALITY_CONTROL));

  return (
    <Field
      name={SELL_AS_ALT_ID}
      component={Select}
      label="Sell As Alternate"
      options={options}
      disabled={disabled}
    />
  );
}

export default withCurrentUser(SellAsAlt);

SellAsAlt.propTypes = {
  alternates: T.arrayOf(
    T.shape({
      id: T.number.isRequired,
      name: T.string.isRequired
    })
  ).isRequired,
  cancelled: T.bool,
  shipped: T.bool,
  exchanged: T.bool.isRequired,
  ...WithCurrentUser
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/Form/PartDetails/SellAsAlt.jsx